import { AnimatePresence, motion } from 'framer-motion'
import { useEffect } from 'react'
import { fireConfetti } from './ConfettiBurst.jsx'
import { play } from '../lib/sounds.js'

export default function BadgeUnlockModal({ badge, onDismiss }) {
  useEffect(() => {
    if (badge) {
      fireConfetti({ origin: { y: 0.4 }, particleCount: 160, spread: 100 })
      play('unlock')
    }
  }, [badge])

  return (
    <AnimatePresence>
      {badge && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onDismiss}
        >
          <motion.div
            className="bg-white rounded-2xl p-10 max-w-sm mx-4 text-center shadow-2xl"
            initial={{ scale: 0.3, rotate: -30, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 220, damping: 18 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-7xl mb-4 animate-badge-unlock">
              {badge.emoji || '🏅'}
            </div>
            <div className="font-display text-3xl text-brand-blue mb-1">Badge unlocked</div>
            <h3 className="text-2xl font-bold text-brand-text mb-2">{badge.name}</h3>
            <p className="text-sm text-brand-text-muted mb-6">{badge.description}</p>
            <button
              onClick={onDismiss}
              className="bg-brand-blue hover:bg-brand-blue-hover text-white font-semibold px-6 py-2.5 rounded-lg transition-colors"
            >
              Nice
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
